/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AlertingHookDto } from './AlertingHookDto';
import type { Criticality } from './Criticality';
import type { DatasetBriefDto } from './DatasetBriefDto';
import type { EntityCustomMetadataDto } from './EntityCustomMetadataDto';
import type { IncidentLightDto } from './IncidentLightDto';
import type { TagDto } from './TagDto';
import type { TimeZoneDto } from './TimeZoneDto';
import type { WorkspaceSummaryDto } from './WorkspaceSummaryDto';

export type RuleInfoDto = {
    canBeQualified: boolean;
    canBeScheduled: boolean;
    canHaveFailingRows: boolean;
    canManuallyRun: boolean;
    criticality: Criticality;
    customMetadata?: Array<EntityCustomMetadataDto>;
    datasets?: Array<DatasetBriefDto>;
    id: string;
    lastIncident?: IncidentLightDto;
    /**
     * @deprecated
     */
    lastRunStatus?: RuleInfoDto.lastRunStatus;
    lastRunTimestamp?: number;
    lastUnresolvedIncident?: IncidentLightDto;
    mails?: Array<AlertingHookDto>;
    msTeams?: Array<AlertingHookDto>;
    muted?: boolean;
    mutedUntil?: number;
    mutingMode?: RuleInfoDto.mutingMode;
    name: string;
    readOnly: boolean;
    ruleLabel: string;
    ruleStatus: RuleInfoDto.ruleStatus;
    ruleTemplateName: string;
    schedule?: string;
    scheduleTimezone?: TimeZoneDto;
    slackChannels?: Array<AlertingHookDto>;
    sourcePlatform: RuleInfoDto.sourcePlatform;
    supportAsCodeYAMLConversion: boolean;
    tags?: Array<TagDto>;
    unresolvedIncidents: number;
    workspace?: WorkspaceSummaryDto;
};

export namespace RuleInfoDto {

    export enum lastRunStatus {
        PENDING = 'PENDING',
        RUNNING = 'RUNNING',
        SUCCESS = 'SUCCESS',
        REQUIRES_YOUR_ATTENTION = 'REQUIRES_YOUR_ATTENTION',
        TECHNICAL_ERROR = 'TECHNICAL_ERROR',
        FAILED = 'FAILED',
    }

    export enum mutingMode {
        INDEFINITE = 'INDEFINITE',
        UNTIL_DATE = 'UNTIL_DATE',
        UNTIL_NEXT_STATUS_IMPROVES = 'UNTIL_NEXT_STATUS_IMPROVES',
        NOT_MUTED = 'NOT_MUTED',
    }

    export enum ruleStatus {
        NOT_EVALUATED = 'NOT_EVALUATED',
        PASSING = 'PASSING',
        NEEDS_ATTENTION = 'NEEDS_ATTENTION',
        FAILING = 'FAILING',
    }

    export enum sourcePlatform {
        SIFFLET = 'SIFFLET',
        DBT = 'DBT',
    }


}
